export default __webpack_public_path__ + "static/media/oedusantana_edupress.84e65784.svg";